// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fnsr-medium-card {
  cursor: pointer;
  transition: transform 0.2s ease;
}

fnsr-medium-card:hover {
  transform: translate(0, -3px);
}`, "",{"version":3,"sources":["webpack://./src/app/media/medium-list/medium-list.component.scss","webpack://./../../../=%3E%20finsuro/finsuro.mail/frontend/src/app/media/medium-list/medium-list.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,+BAAA;ACCF;;ADEA;EACE,6BAAA;ACCF","sourcesContent":["fnsr-medium-card {\n  cursor: pointer;\n  transition: transform 0.2s ease;\n}\n\nfnsr-medium-card:hover {\n  transform: translate(0, -3px);\n}\n","fnsr-medium-card {\n  cursor: pointer;\n  transition: transform 0.2s ease;\n}\n\nfnsr-medium-card:hover {\n  transform: translate(0, -3px);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
